module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdUlEQVQoFZWSwQ2AIBAER+PfVuhAurkvpfClG0qwFSvAXMJD8UDdH8nO7d6FqZTCHy1Xr4hEwAEhpbRbc+bmreYNyCLivgABOIC1B92AWsOPoDbBguIQeNMDqBVyna4pupedYJh9e942Qft2zb0dumbVv68BnH6yLXOE2rrYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_msg_qa_answer_arrow.png
// module id = TpAe
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82